import { mdiAccountOutline, mdiChevronLeft } from "@mdi/js";
import Icon from "@mdi/react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useToggle } from "usehooks-ts";

import clsx from "clsx";
import Header from "components/Header";
import Modal from "components/Modal";
import { routes } from "constants/routes";
import { PRICING_PLAN_BENEFITS } from "constants/user-settings";
import { useColorScheme } from "hooks/useColorScheme";
import { useUserFeature } from "hooks/useUserFeature";
import { selectStripeSubscribeStatus } from "store/userSetting/selector";

export default function BillingHeader() {
  const navigate = useNavigate();
  const { isFactoringApproved } = useUserFeature();
  const stripeSubscriptionStatus = useSelector(selectStripeSubscribeStatus);
  const [isBenefitsModalOpen, toggleBenefitsModal] = useToggle();
  const { currentIsDark } = useColorScheme();

  if (isFactoringApproved === "approved") {
    return (
      <div className="flex items-center justify-between flex-1 gap-3">
        <div className="flex">
          <button onClick={() => navigate(routes.SETTINGS)}>
            <Icon path={mdiChevronLeft} className="size-8" />
          </button>
          <h4 className="text-2xl font-medium">Billing</h4>
        </div>
      </div>
    );
  }

  if (stripeSubscriptionStatus.info) {
    return (
      <Header label="Current Plan" goBackPath={routes.SETTINGS} headerIcon=" " isHideDesktop />
    );
  }

  return (
    <div className="flex items-center justify-between flex-1 gap-3">
      <div className="flex">
        <button onClick={() => navigate(routes.SETTINGS)}>
          <Icon path={mdiChevronLeft} className="size-8" />
        </button>
        <h4 className="text-2xl font-medium">Billing</h4>
      </div>
      <div className="flex justify-between gap-3.5">
        <button onClick={toggleBenefitsModal} className="underline">
          View Benefits
        </button>
        <button
          className="bg-transparent rounded-full size-6"
          onClick={() => navigate(routes.SETTINGS_HELP)}>
          <Icon path={mdiAccountOutline} />
        </button>
      </div>

      <Modal
        isOpen={isBenefitsModalOpen}
        closeModal={toggleBenefitsModal}
        wrapperClass="!my-auto desktop:!min-h-fit"
        dialogClass="!bg-foreground !pt-3.5 !pb-10 !border !border-card !overflow-y-auto"
        closeClass="!top-24 !right-5 !bg-transparent">
        <h3 className="pl-0.5 text-xl font-medium">Full Access Benefits</h3>

        <div className="h-full mt-6 overflow-y-auto">
          <ul className="grid grid-cols-2 gap-3 text-xs">
            {PRICING_PLAN_BENEFITS.map((item) => (
              <li
                key={item.id}
                className={clsx(
                  "mobile:bg-gradient-to-r mobile:from-card mobile:to-foreground desktop:bg-background rounded-base col-span-1 p-2.5 flex flex-col gap-2.5",
                  !currentIsDark && "drop-shadow-[0_2px_4.5px_#9E9E9E33]"
                )}>
                <item.icon />
                <p>{item.content}</p>
              </li>
            ))}
          </ul>
        </div>
      </Modal>
    </div>
  );
}
